import { createApi } from "@reduxjs/toolkit/query/react";

import { appBaseQuery } from "config/api.config";

export const systemApi = createApi({
  reducerPath: "system",
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    getEnumInfo: builder.query<
      Record<string, number>,
      { enumName: string } | undefined
    >({
      query: (params) => ({
        url: "System/GetEnumInfo",

        params,
      }),
    }),
  }),
});

export const { useGetEnumInfoQuery, useLazyGetEnumInfoQuery } = systemApi;
